import type { AppointmentHandback } from '../api/types';

// Terminrückgabe an den Support: Bezeichnungen und die 180-Minuten-Regel (wie im Backend, appointments/handback.go).

export type HandbackKind = AppointmentHandback['kind'];
export type HandbackResolution = NonNullable<AppointmentHandback['resolution']>;

// Bis 180 Minuten vor Beginn ist eine Rückgabe normal, darunter dringend (sofortige Eskalation).
export const HANDBACK_URGENT_MINUTES = 180;

export const handbackKindLabels: Record<HandbackKind, string> = {
  RESCHEDULE: 'Verschiebung gewünscht',
  CANCEL: 'Absage gewünscht',
  RETURN: 'Makler kann nicht – Support entscheidet',
};

export const handbackKindOptions: { kind: HandbackKind; label: string; hint: string }[] = [
  { kind: 'RESCHEDULE', label: 'Termin verschieben lassen', hint: 'Der Support vereinbart mit dem Kunden eine neue Zeit.' },
  { kind: 'CANCEL', label: 'Termin absagen lassen', hint: 'Der Support sagt dem Kunden ab.' },
  { kind: 'RETURN', label: 'An den Support zurückgeben', hint: 'Der Support entscheidet: verschieben, anderer Makler oder Absage.' },
];

export const handbackResolutionLabels: Record<HandbackResolution, string> = {
  RESCHEDULED: 'Termin verschoben',
  CANCELED: 'Termin abgesagt',
  REASSIGNED: 'An einen anderen Makler übergeben',
  KEPT: 'Termin bleibt bestehen',
  WITHDRAWN: 'Vom Makler zurückgezogen',
  CLOSED: 'Termin abgeschlossen',
};

// minutesUntil: ganze Minuten bis zum Beginn (negativ = hat begonnen).
export function minutesUntil(startIso: string, now: number): number {
  return Math.floor((new Date(startIso).getTime() - now) / 60000);
}

// leadTimeLabel: Abstand bis zum Beginn („in 2 Std. 5 Min.“).
export function leadTimeLabel(minutes: number): string {
  if (minutes < 0) return 'hat bereits begonnen';
  if (minutes < 60) return `in ${minutes} Min.`;
  if (minutes < 48 * 60) {
    const m = minutes % 60;
    return m ? `in ${Math.floor(minutes / 60)} Std. ${m} Min.` : `in ${Math.floor(minutes / 60)} Std.`;
  }
  return `in ${Math.floor(minutes / (24 * 60))} Tagen`;
}

// isUrgentHandback: Rückgabe jetzt wäre dringend bzw. ist inzwischen dringend (Priorität URGENT).
export function isUrgentHandback(h: Pick<AppointmentHandback, 'ticket_priority' | 'urgent' | 'escalated_at'>): boolean {
  return h.urgent || !!h.escalated_at || h.ticket_priority === 'URGENT';
}
